import React, { Component } from "react";

import { getAllMultiplayerGames } from "../../../modules/multiplayer_game";

import socketIOClient from "socket.io-client";

import Constants from "../../../constants/constants";
import withStaticImages from "../../../services/utils/imageNameRetriever";

import "./online-private-rooms.css";


class OnlinePrivateRooms extends Component {
  //expecting the user token to be part of the props object
  constructor(props) {
    super(props);
    const ENDPOINT = Constants.GAME_SERVER_URL;

    this.state = {
      is_open: false,
      creating_room: false,
      room_code: false,
      game_options: [],
      chosen_game: "-1",
    };

    this.socket = socketIOClient(ENDPOINT, { transports: ["websocket"] });

    this.socket.on("room_creation_result", this.creationResult.bind(this));
  }

  copyCode() {
    this.codeElement.select();
    /* Select the text field */
    //this.codeElement.select();
    this.codeElement.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");

    /* Alert the copied text */
    alert("copied to clipboard!");
  }

  creationResult(result) {
    console.log(result);

    if (result.success) {
      this.setState({ room_code: result.room_code });
    }
  }

  async componentDidMount() {
    let { token } = this.props;
    var availableGames = await getAllMultiplayerGames(token);

    if (availableGames) {
      var data = availableGames.data;

      if (data.success) {
        console.log(availableGames);
        this.setState({ game_options: data.games });
      }
    }
  }

  async submitPrivateRoom() {
    var { token } = this.props;
    var { chosen_game } = this.state;

    var data = {
      game_name: chosen_game,
      token: token,
    };

    this.socket.emit("createRoom", data);
  }

  onGameChange(event) {
    this.setState({
      chosen_game: event.target.value,
    });
  }

  hideDialog() {
    this.setState({ is_open: false });
  }

  openCreationDialog() {
    this.setState({ is_open: true });
  }

  printRoomInformation() {
    var { room_code } = this.state;
    var { token } = this.props;
    var gameURL =
      Constants.getPlayContentUrl() +
      "/play_game?room_code=" +
      room_code +
      "&auth=" +
      token;

    let togetherURL = new URL(window.location.href)
    togetherURL.pathname = "/together/";
    let key_list = [];
    // drop all the search params from URL
    for(let key of togetherURL.searchParams.keys()){key_list.push(key);}
    for(let key of key_list){ togetherURL.searchParams.delete(key);}
    return (
      <div className="join-room-now-note">
        <div><strong>Success!</strong> Your game room has been created and is now open.</div>
        <div className="private-room-code-section">
          <input
            className="private-room-code"
            ref={(element) => (this.codeElement = element)}
            value={room_code}
            readOnly
          />
          <div className="copy-code" onClick={this.copyCode.bind(this)}>
            <i className="fa fa-clone"></i>Copy Code
          </div>
        </div>
        <div className="private-room-join-message">
          People will be able to join your game by using the room code here:
        </div>
        <div id="private_room_link">{togetherURL.href}</div>
        <a href={gameURL}>
          <button className="join-room-now">Join your room now!</button>
        </a>
      </div>
    );
  }

  render() {
    let { is_open, game_options, chosen_game, room_code } = this.state;

    var validGame = chosen_game !== "-1";

    return (
      <div id="private_rooms_console">
        {is_open && (
          <div
            className="private-game-modal"
            onClick={this.hideDialog.bind(this)}
          ></div>
        )}
        {is_open && (
          <div className="private-game-dialog-container">
            <div className="private-game-dialog">
              <div id="private_room_title">Private Game</div><br/>
              {!room_code && (
                <div id="private_room_subtitle">
                  Invite a family member or a friend to a private live game.
                </div>
              )}
              {!room_code && (
                <div className="game-selection-form">
                  <select
                    id="online_game_selection"
                    onChange={this.onGameChange.bind(this)}
                  >
                    <option value="-1">Choose a Game:</option>
                    {game_options.map((game, i) => {
                      return <option key={i} value={game.name}>{game.name}</option>;
                    })}
                  </select>
                  <button
                    disabled={!validGame && !room_code}
                    onClick={this.submitPrivateRoom.bind(this)}
                    className="private-multiplayer-room-submit-button"
                  >
                    Submit
                  </button>
                </div>
              )}
              {room_code && this.printRoomInformation()}
            </div>
          </div>
        )}
        <div className="multiplayer_card_container">
          <div className="private-game-card">
            <div className="room_card_top_label center">Private Game</div>
            <img
              alt="multiplayer_card_background_image"
              className="multiplayer_card_background_image"
              src={this.props.getImage('arcade_machine.png')}
            />
            <button
              className="private-game-card-create-button"
              onClick={this.openCreationDialog.bind(this)}
            >
              CREATE PRIVATE GAME
            </button>
          </div>
          <div className="room_card_text">
            <div className="room_card_text_title">
              <i className="fa fa-lock multiplayer_sub_icon"></i>Invite to a
              private game
            </div>
            <div className="room_card_text_description">
              Invite family members or friends to a private live game.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStaticImages('multiplayer_card_images',OnlinePrivateRooms);



// WEBPACK FOOTER //
// ./src/components/containers/online-private-rooms/online-private-rooms.js